<script setup>
import { onMounted, ref, watch, defineProps } from 'vue';
import i18n from "@/i18n"
import { showMessage } from "@/utils/hooks/message"
import { getFileUrl } from "@/service"
import { getDashboardProduct } from "@/service/apiList/dashboard"
import { gethscodeByTemplate } from "@/service/apiList/productLine"
import usetablePageNation from "@/utils/hooks/usetablePageNation" //分页hooks
import dailog from './dailog.vue';
import PreviewImg from "@/components/common/PreviewImg";
// import QRCode from "qrcode";
import { useRoute } from 'vue-router';
import vectorSvg from "@/assets/images/svg/vector.svg"
import { getLangValue, makeQrCode } from "@/utils/common"; //获取后端语言
const props = defineProps({
    category_id: {
        type: Number,
        required: true,
        default: 3   // 质量 3  碳足迹 5
    }
})
const route = useRoute();
const activeImageSrc = ref('')
const showPreviewImg = ref(false)
const visible = ref(false)
const tableInfo = ref([])
const typeList = ref([])
const fileList = ref([])
const table_head = ref([
    { name: 'NO.', width: '4%', checked: true, type: 'index' },
    { name: getLangValue("product-template.productName"), width: '10%', key: 'p_name', checked: true }, //产品名称
    { name: getLangValue('product-template.productImg'), width: '8%', key: 'picture', url: 'product_image', checked: true }, //产品图片
    { name: getLangValue("dashboard.batchtotalquantity"), width: '10%', key: 'batch_size', checked: true }, //batch 批次总量
    { name: getLangValue('product-management', "code_pid_gtin"), width: '8%', key: 'code', url: 'code1', checked: true }, //PID二维码
    { name: getLangValue("dashboard.evaluate"), width: '8%', key: 'evaluate', checked: true, show: true }, //评价
    { name: 'HS Code', width: '8%', checked: true, show: true, key: 'hscode' }, //HScode
    { name: getLangValue("dashboard.quality.tableHeader7"), width: '8%', key: 'group_name', checked: true, show: true }, //指标组
    { name: getLangValue("hscode.indicatorName"), width: '8%', key: 'name', checked: true, show: true }, //指标名称
    { name: getLangValue("dashboard.indicatorValues"), width: '8%', key: 'value', checked: true, show: true }, //指标数值
    { name: getLangValue("attribute.unit"), width: '8%', key: 'unit', checked: true, show: true }, //单位
    { name: getLangValue("attribute.reference"), key: 'reference', checked: true, show: true },    //参考标准attribute
    { name: getLangValue("product-template.report1"), width: '8%', key: 'has_report', checked: true, show: true },//检测报告
    { name: getLangValue("product-template.testingOrganization"), width: '8%', key: 'testing_institution', checked: true, show: true },//检测机构
    { name: getLangValue("dashboard.quality.tableHeader8"), width: '8%', key: 'code', url: 'code2', checked: true, show: true },//机构二维码
    { name: getLangValue("dashboard.Certificationdate"), width: '10%', key: 'certification_date', checked: true, show: true },//认证日期
    { name: getLangValue("dashboard.Validitycertification"), width: '8%', key: 'validity_period_of_certification', checked: true, show: true },//认证有效期
    { name: getLangValue("dashboard.Certificationbody"), width: '8%', key: 'certification_body', checked: true, show: true },//认证机构
])
const hscodeList = ref([])
const pageSizeOption = [10, 20, 30, 40, 50]
const loading = ref(false)
const { total, currentPage, pageSize, pageOption } = usetablePageNation()
const type = ref('')
const hscode = ref('')
const keyword = ref('')
const tableAllInfo = ref([])
const getDataList = async () => {
    loading.value = true
    //获取数据
    let params = {
        page: currentPage.value - 1,
        limit: pageSize.value,
        // type: type.value,
        category_id: props.category_id,
        hscode_id: hscode.value,
        keyword: keyword.value.trim(),
    }
    if (!params.hscode_id) {
        showMessage('danger', getLangValue("dashboard.fillDataMessage1"))
        return
    }
    loading.value = true;
    const resp = await getDashboardProduct(params);
    loading.value = false;
    if (resp.code == 0) {
        tableAllInfo.value = []
        if (resp.payload.data.length) {
            // for (const item in resp.payload) {
            //     let m = { ...resp.payload[item] }
            //     m.p_id = m.id
            //     m.p_name = m.name
            //     if (m.index_standard_list.length) {
            //         for (const item1 in m.index_standard_list) {
            //             m.index_standard_list[item1]['i_id'] = m.index_standard_list[item1].id
            //             m = { ...m, ...m.index_standard_list[item1], ...m.index_standard_list[item1].index_standard }
            //             tableAllInfo.value.push(m);
            //         }
            //     }
            // }
            total.value = resp.payload.total
            tableInfo.value = resp.payload.data
            tableInfo.value.forEach(async element => {
                if (element.database_list?.pid) {
                    const reps = await makeQrCode({ type: 2, id: element.database_list.id })
                    if (reps) {
                        element.code1 = reps
                    }
                }
                // 如果有检测机构id 才生成二维码
                if (element?.testing_institution_user?.id) {
                    // 需要加id
                    const reps = await makeQrCode({ type: 1, id: element.testing_institution_user.id })
                    if (reps) {
                        element.code2 = reps
                    }
                    console.log(1);
                }
            });
        } else {
            total.value = 0
            tableInfo.value = []
            showMessage('info', getLangValue('base.no_data'))
        }
        // setTableData();
    }
}
const dailogInfo = ref({
    title: '',
    header: [
        { label: 'ID', key: 'index' },
        { label: 'xaa', key: 'key1' },
        { label: 'xaxaa', key: 'key2' },
    ],
    list: [
        {
            key1: 'xx',
            key2: 'xx',
        }, {
            key1: 'xx',
            key2: 'xx',
        }, {
            key1: 'xx',
            key2: 'xx',
        }, {
            key1: 'xx',
            key2: 'xx',
        }, {
            key1: 'xx',
            key2: 'xx',
        }, {
            key1: 'xx',
            key2: 'xx',
        }, {
            key1: 'xx',
            key2: 'xx',
        }, {
            key1: 'xx',
            key2: 'xx',
        },
    ],
})
const search = () => {
    //搜索
    currentPage.value = 1;
    getDataList()
}

// const setTableData = () => {
//     // 根据分页
//     // 根据group筛选
//     let startIndex = ((currentPage.value - 1) * pageSize.value) - 1 < 0 ? 0 : ((currentPage.value - 1) * pageSize.value);
//     let endIndex = startIndex + pageSize.value;
//     total.value = tableAllInfo.value.length
//     tableInfo.value = tableAllInfo.value.slice(startIndex, endIndex)
//     // console.log(tableInfo.value);
//     tableInfo.value.forEach(element => {
//         if (element.pid) {
//             let opts = {
//                 errorCorrectionLevel: "M",
//                 margin: 1,
//                 width: 300,
//                 height: 300,
//                 quality: 1,
//                 color: {
//                     dark: "#000",
//                     light: "#FFF",
//                 },
//             };
//             let href = window.location.href
//             let arr = href.split('/#/')
//             let website = arr[0]
//             QRCode.toDataURL(`${website}/#/code?content=${element.name}`, opts, (err, url) => {
//                 if (err) throw err;
//                 element.code1 = url;
//             });
//         }
//         if (element.testing_institution) {
//             let opts = {
//                 errorCorrectionLevel: "M",
//                 margin: 1,
//                 width: 300,
//                 height: 300,
//                 quality: 1,
//                 color: {
//                     dark: "#000",
//                     light: "#FFF",
//                 },
//             };
//             let href = window.location.href
//             let arr = href.split('/#/')
//             let website = arr[0]
//             QRCode.toDataURL(`${website}/#/code?content=${element.testing_institution}`, opts, (err, url) => {
//                 if (err) throw err;
//                 element.code2 = url;
//             });
//         }
//     });
// }

const getIndicatorCategory = async () => {
    // 获取模板-目标市场
    loading.value = true;
    const resp = await gethscodeByTemplate();
    loading.value = false;
    if (resp) {
        typeList.value = resp.payload.filter(item => item.destination_market_list.length).map(item => {
            return {
                label: item.name,
                label_en: item.name_en,
                value: item.name,
                children: item.destination_market_list.map(item1 => {
                    return {
                        label: item1.title,
                        label_en: item1.title_en,
                        value: item1.id,
                        database_template_list: item1.database_template_list
                    }
                })
            }
        })
        type.value = route.query.product_template_name
        hscode.value = route.query.hscode
        keyword.value = route.query.keyword.trim()
        changeTemplate(0)
        getDataList();
    }
}

const changeTemplate = (index = 1) => {
    //模板-目标市场切换
    if (index == 1)
        hscode.value = ''
    if (type.value.length) {
        let arr = typeList.value.filter(item => item.value === type.value[0] && item.children.filter(item1 => item1.value === type.value[1]).length)
        if (arr.length) {
            // 获取shcode
            let arr1 = arr[0].children.filter(item => item.value === type.value[1])
            if (arr1.length) {
                hscodeList.value = arr1[0].database_template_list.map(item => {
                    return {
                        id: item.hscode?.id,
                        title: item.hscode?.title,
                        title_en: item.hscode?.title_en,
                    }
                })
            }
        }
    } else {
        hscodeList.value = []
    }
}

// const getChecked = () => {
//     return table_head.value.filter(item => item.checked).length
// }


const getStatus = (info) => {
    /**根据状态显示值 */
    // v-if="detailInfo1.status == 1 && detailInfo1.sub_status === 0"
    // if (info.database_list  && info.database_list.status == 1 && info.database_list.sub_status === 0) {
    //     //通过检测
    //     return getLangValue("business_products_management.testedSuccessfully")
    // }
    // if (info.database_list &&  info.database_list.status == 2 && info.database_list.sub_status === 0) {
    //     //通过检测
    //     return getLangValue("business_products_management.certificationPassed")
    // }
    // 公开产品 且审核通过了的
    if(info.database_list?.public_type == 2 && (info.database_list?.status == 1 || info.database_list?.status == 2) && info.database_list?.sub_status === 0)  {
        return true
    }
    return false
}


const showImageCode = (url) => {
    /**查看二维码大图 */
    activeImageSrc.value = url;
    if (activeImageSrc.value == "") {
        return;
    }
    showPreviewImg.value = true;
}


const getImage = (info) => {
    let arr = fileList.value.filter(item => item.id == info.database_list.picture[0])
    return arr.length ? arr[0].url : ''
}

const showReport = async (report) => {
    // 显示report里面的文件信息
    // 如果是图片才展示
    const resp = await getFileUrl({ attachments: report[0] })
    if (resp.code ==0) {
        // 判断是否图片
        if (resp.payload[0].name.match(/\.(jpg|jpeg|png|gif)$/i)) {
            activeImageSrc.value = resp.payload[0].url;
            showPreviewImg.value = true;
        }else{
            // 提示无法预览
            showMessage('info', getLangValue('base.not_support_preview'))
        }
    }
}

onMounted(() => {
    getIndicatorCategory();
})

watch(pageSize, () => {
    currentPage.value = 1;
    getDataList();
})

watch(currentPage, () => {
    getDataList();
})

watch(tableInfo, () => {
    fileList.value = []
    let imageList = tableInfo.value.filter(item => item.database_list && item.database_list['picture'] && item.database_list['picture'].length).map((item) => item.database_list['picture'][0])
    // 重复图片 去重
    imageList = [...new Set(imageList)]
    let imgStr = imageList.join(',')
    if (imgStr)
        getFileUrl({ attachments: imgStr }).then(resp => {
            if (resp) {
                fileList.value = resp.payload
            }
        })

},)

</script>
<template>
    <div class="qualitySearchTable1 px-3 py-2 " style="height: calc(100% - 1rem) " v-loading="loading">
        <div class="d-flex justify-content-between align-items-center">
            <div class="search d-flex align-items-center">
                <!-- <el-select @change="changeTemplate(1)" v-model="type" filterable clearable
                    :placeholder="getLangValue('dashboard.dataBaseType')" style="max-width: 280px; height: 38px; flex: 1;">
                    <el-option v-for="item in typeList" :key="item.value" :label="item.name" :value="item.name" />
                </el-select> -->
                <el-cascader style="width: 280px; height: 38px;" v-model="type" :options="typeList"
                    :placeholder="getLangValue('dashboard.dataBaseType')"
                    :props="{ label: i18n.global.locale == 'en' ? 'label_en' : 'label', }" @change="changeTemplate(1)" />

                <el-select v-model="hscode" filterable clearable class="mx-2" placeholder="HS Code"
                    style="max-width: 280px; height: 38px;">
                    <el-option v-for="item in hscodeList" :key="item.value"
                        :label="i18n.global.locale == 'en' ? item.title_en : item.title" :value="item.id" />
                </el-select>
                <div class="form-icon" style="max-width: 360px; flex: 1;">
                    <input style="width: 100%;" clearable class="form-control form-control-icon" v-model="keyword"
                        required :placeholder="getLangValue('dashboard.input3_1')" />
                    <i class="ri-search-line"></i>
                </div>
            </div>
            <div class="d-flex">
                <div class="d-flex" style="color: white;">
                    <!-- <button id="btnGroupVerticalDrop1" type="button" class="btn dropdown-toggle"
                        data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                        style="padding: 0 3px; color: white;">
                        <i class="ri-filter-line"></i>{{ getChecked() }}{{ getLangValue('dashboard.quality.selectLegnth') }}
                    </button>
                    <div class="dropdown-menu " aria-labelledby="btnGroupVerticalDrop1">
                        <template v-for="(hItem) in table_head" :key="hItem">
                            <div class="m-2 d-flex align-items-center">
                                <input class="form-check-input mt-0 mx-2" type="checkbox" v-model="hItem.checked"
                                    aria-label="Checkbox for following text input">
                                <span>{{ hItem.name }}</span>
                            </div>
                        </template>
</div> -->
                </div>
                <button type="button" class="btn btn-success mx-3" @click="search()" style="min-width: 93px;">
                    {{ getLangValue("base.search") }}
                </button>
            </div>
        </div>
        <div style="flex-direction: column; height: calc(100% - 40px);">
            <div class="my-table my-2" id="my-table">
                <!-- 表格信息 -->
                <div style="height:calc(100% - 60px - 1rem); overflow-y: auto;" class="my-scroll-bar">
                    <table class="table table-nowrap ">
                        <!-- table-nowrap -->
                        <thead class="table-light">
                            <tr>
                                <template v-for="(head, index) in table_head.filter(item => item.checked)" :key="index">
                                    <th v-if="head.key == 'reference'" scope="col"
                                        style="color: #212529;min-width: 200px">
                                        <div class="d-flex align-items-center">{{ head.name }}</div>
                                    </th>
                                    <th v-else scope="col" :key="index" :width="head.width">
                                        <div :class="i18n.global.locale == 'en' ? 'en-word-break' : 'zh-word-break'"
                                            class="d-flex align-items-center"
                                            style="color: #212529; min-width: 60px; word-break: break-all; white-space: normal;">
                                            {{ head.name }}</div>
                                    </th>
                                </template>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(info, index) in tableInfo" :key="index" style="vertical-align: middle;">
                                <template v-for="(item, kk) in table_head.filter(item => item.checked)" :key="kk">
                                    <td style="word-wrap: break-word; white-space: normal;  padding: 0.75rem 0.4rem; max-width: 200px;"
                                        :style="item.type == 'index' ? { minWidth: '40px' } : { minWidth: '90px' }">
                                        <span v-if="item.key == 'picture' || item.key == 'code'" class="cursor-pointer">
                                            <template v-if="item.key == 'code'">
                                                <img :src="info[item.url]" v-if="info[item.url]" class="cursor-pointer"
                                                    :title="item.url == 'code1' ? `FBD`+info.database_list.pid : info.oid"
                                                    style="width: 48px;height: 48px;"
                                                    @click="showImageCode(info[item.url])" />
                                            </template>
                                            <template v-else>
                                                <!-- v-if="fileList.length && info.picture && info.picture.length" -->
                                                <img v-if="fileList.length && info.database_list && info.database_list.picture.length"
                                                    :src="getImage(info)" class="cursor-pointer"
                                                    style="width: 48px;height: 48px;"
                                                    @click="showImageCode(getImage(info))" />
                                            </template>
                                        </span>
                                        <span v-else>
                                            <template v-if="item.key == 'hscode'">
                                                {{ i18n.global.locale == 'en' ? info.hscode?.title_en : info.hscode?.title
                                                }}
                                            </template>
                                            <template v-else-if="item.key == 'evaluate'">
                                                {{ getStatus(info) ? getLangValue('dashboard.quality.pass') :
                                                    getLangValue('dashboard.quality.fail') }}
                                            </template>
                                            <template v-else-if="item.key == 'p_name'">
                                                {{ info.database_list && info.database_list.name }}
                                            </template>
                                            <template v-else-if="item.key == 'batch_size'">
                                                {{ info.database_list && info.database_list[item.key] }}
                                            </template>
                                            <template
                                                v-else-if="item.key == 'group_name' || item.key == 'name' || item.key == 'unit'">
                                                {{ info.index_standard && info.index_standard[i18n.global.locale ==
                                                'en'?`${item.key}_en` :item.key] }}
                                            </template>
                                            <template v-else-if="item.key == 'has_report'">
                                                <img :src="vectorSvg" style="width: 24px;" @click="showReport(info.report)" class="cursor-pointer"
                                                    v-if="info.report && info.report.length" />
                                            </template>
                                            <div v-else-if="item.key == 'reference'"
                                                :title="info.index_standard[item.key]"
                                                style="width: 200px; max-height: 60px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">
                                                {{ kk == 0 ? index + 1 : info.index_standard[item.key] }}
                                            </div>
                                            <template v-else>
                                                {{ kk == 0 ? index + 1 : info[item.key] }}
                                            </template>
                                        </span>
                                    </td>
                                </template>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <!-- 分页 -->
                <Pagination v-if="total" v-model:page="currentPage" v-model:perPage="pageSize" :pages="pageOption"
                    :prePageOption="pageSizeOption" :tab_info_length="total" class="me-5 my-3 my-pagination">
                </Pagination>
            </div>
        </div>
        <dailog v-model:visible="visible" :dailogInfo="dailogInfo" :myWidth="400" v-if="visible">
        </dailog>
        <PreviewImg v-model:showPreviewImg="showPreviewImg" :src="activeImageSrc" :myWidth="400" v-if="showPreviewImg">
        </PreviewImg>
    </div>

</template>
<style scoped lang="scss">
.qualitySearchTable {
    .search {
        flex: 1;
        height: 38px;

        :deep(.el-input--suffix) {
            // width: 110px;
            height: 100%;
        }

        :deep(.el-select__wrapper) {
            background-color: #4a5056;
            height: 100%;
        }

        :deep(.el-input__wrapper) {
            background-color: #4a5056;
        }

        :deep(.el-select__placeholder.is-transparent) {
            color: #889AA5 !important;
        }

        :deep(.el-select__selected-item) {
            color: white;
        }


        :deep(.el-input__inner) {
            color: white;
        }

        .form-icon {
            display: inline-block;

            i {
                color: white
            }
        }

        .form-control {
            background-color: #4a5056;
            color: white;
            display: inline-block;
        }
    }

    .my-table {
        flex: 1; //way-2
        height: 100%; //way-2

        // max-height: 500px; // way-1
        table {
            color: white;
        }

        .my-pagination {
            color: white;

            :deep(.page_total) {
                color: white !important;
            }
        }
    }
}

.qualitySearchTable1 {
    .search {
        flex: 1;
        height: 38px;

        :deep(.el-input--suffix) {
            // width: 110px;
            height: 100%;
        }

        :deep(.el-select__wrapper) {
            // background-color: #4a5056;
            height: 100%;
        }

        :deep(.el-input__wrapper) {
            // background-color: #4a5056;
        }

        :deep(.el-select__placeholder.is-transparent) {
            font-size: 0.8125rem;
            color: #878a99 !important;
        }

        :deep(.el-cascader .el-input__inner) {
            &::placeholder {
                font-size: 0.8125rem;
                color: #878a99 !important;
            }
        }

        :deep(.el-select__selected-item.el-select__placeholder) {
            font-size: 0.8125rem;
            color: #212529;
        }
        :deep(.el-input__inner) {
            font-size: 0.8125rem;
            color: #212529;
        }

        .form-icon {
            display: inline-block;

            i {
                color: #212529
            }
        }

        .form-control {
            // background-color: #4a5056;
            color: #212529;
            display: inline-block;
        }
    }

    .my-table {
        flex: 1; //way-2
        height: 100%; //way-2

        // max-height: 500px; // way-1
        table {
            color: #212529;
        }

        .my-pagination {
            color: #212529;

            :deep(.page_total) {
                color: #212529 !important;
            }
        }
    }
}
</style>